<div> Name: {{preview?.name}}</div>
<div> Current Slot: {{currentIndex + 1}}</div>
<div> Duration: {{media[currentIndex]?.duration}}s</div>
<div class="d-flex align-items-center justify-content-center">
  <div style="width: 500px; height: 300px; overflow: hidden;">
    <ng-container *ngIf="preview && preview.contentType && !preview.processing">
      <sb-comp-medium #mediumComponent
                      [muted]="muted"
                      [customWidth]="'500px'"
                      [customHeight]="'300px'"
                      [classes]="'object-fit-contain'"
                      [medium]="preview" [thumbnailSize]="'L'"
                      (ended)="playPause? nextMedium(): mediumComponent.videoElement?.play()">
      </sb-comp-medium>
    </ng-container>
  </div>
</div>
<div class="row mt-2">
  <div class="col">
    <div class="w-100 d-flex align-items-center justify-content-center">
      <button (click)="lastMedium()" class="btn btn-primary mr-2">
        <sb-icon icon="backwardFilled"></sb-icon>
      </button>
      <button (click)="togglePlayPause()" class="btn mr-2" [class.btn-success]="!playPause"
              [class.btn-warning]="playPause"
              [ngbTooltip]="playPause? ('lang.playlist.playPause'|translate) : ('lang.playlist.pausePlay'|translate)"
              container="body">
        <sb-icon *ngIf="playPause" icon="pause" [hover]="hover" (mouseenter)="hover = true"
                 (mouseleave)="hover = false"></sb-icon>
        <sb-icon *ngIf="!playPause" icon="play" [hover]="hover" (mouseenter)="hover = true"
                 (mouseleave)="hover = false"></sb-icon>
      </button>
      <button (click)="nextMedium()" class="btn btn-primary mr-2">
        <sb-icon icon="forwardFilled"></sb-icon>
      </button>
      <button *ngIf="preview?.contentType?.indexOf('video') !== -1" (click)="toggleMute()" class="btn mr-2"
              [class.btn-hover-primary--active]="muted"
              [class.btn-hover-primary]="!muted">
        <sb-icon *ngIf="muted" icon="muteOn"></sb-icon>
        <sb-icon *ngIf="!muted" icon="muteOff"></sb-icon>
      </button>
      <button (click)="cancel()" class="btn btn-danger mr-2">
        <sb-icon icon="cancel"></sb-icon>
      </button>
    </div>
  </div>
</div>
